import { createRoot } from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import App from './App';
import { awsAuthConfig, isConfigured } from './configs/aws';

if (isConfigured) Amplify.configure(awsAuthConfig);
const root = createRoot(document.getElementById('root'));
root.render(<App />);
